<ng-template cdk-portal>
    <div *ngIf="isVisible" @fadeAnimation (@fadeAnimation.done)="!isVisible && close()" class="w-full">
        <ng-content></ng-content>
    </div>
</ng-template>